import { Routes, Route } from 'react-router-dom';
import OperatingCost from '../child_components/OperatingCost';
import FinanceAppointments from '../child_components/FinanceAppointments';
import Payment from '../child_components/Payment';
import Revenue from '../child_components/Revenue';
import ResourceCharges from '../child_components/ResourceCharges';
import PendingInvoices from '../child_components/PendingInvoices';
import FleetEstimates from '../child_components/FleetEstimates';
import FleetStatements from '../child_components/FleetStatements';
import FleetInvoice from '../child_components/FleetInvoice';
import FinanceFleetAppointments from '../child_components/FinanceFleetAppointments';
import FleetOpenEstimates from '../child_components/FleetOpenEstimates';

function Finance() {

    return (
        <div>
            <Routes>
                <Route path='/pending_invoices' element={<PendingInvoices />} />
                <Route path='/fleet_estimates' element={<FleetEstimates />} />
                <Route path='/fleet_open_estimates' element={<FleetOpenEstimates />} />
                <Route path='/fleet_invoice' element={<FleetInvoice />} />
                <Route path='/fleet_statements' element={<FleetStatements />} />
                <Route path='/resource_charges' element={<ResourceCharges />} />
                <Route path='/operating_cost' element={<OperatingCost />} />
                <Route path='/appointment' element={<FinanceAppointments />} />
                <Route path='/fleet_appointment' element={<FinanceFleetAppointments />} />
                <Route path='/payment' element={<Payment />} />
                <Route path='/revenue' element={<Revenue />} />
            </Routes>
        </div>
    )
}

export default Finance;